import {
  AUTH_LOGIN,
  AUTH_MAGIC_LINK_LOGIN,
  AUTH_PASSWORD_NEW,
  AUTH_PASSWORD_RESET_CONFIRMATION
} from 'portal/constants/Routes';

import {
  buttonContainerStyles,
  buttonStyles,
  forgotLinkButtonStyles,
  loginButtonStyles,
  loginContainerStyles
} from 'auth/AuthStyles';
import { postData } from 'helpers/RequestHelper';
import { REQUIRED_ERROR, SET_DATA, SET_ERROR } from 'helpers/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { validateAction } from 'sharedActions/sharedActions';
import ArrowPhone from 'images/ContainerIcons/ArrowPhone.svg';
import Button from '@opploans/button-component/Button';
import LinkButton from '@opploans/link-button-component/LinkButton';
import Password from 'components/component_lib/Password';
import React from 'react';
import RebrandEmail from 'fields/rebrand/RebrandEmail';

function EmailPasswordLoginForm({ navigate }) {
  const email = useSelector((state) => state.email);
  const password = useSelector((state) => state.password);
  const errors = useSelector((state) => state.errors);
  const [loading, setLoading] = React.useState(false);
  const [passwordError, setPasswordError] = React.useState('');
  const dispatch = useDispatch();

  const validatePassword = (value) => {
    if (value) {
      setPasswordError('');
      dispatch({ type: SET_ERROR, payload: { password: '' } });
    } else {
      setPasswordError(REQUIRED_ERROR);
      dispatch({ type: SET_ERROR, payload: { password: REQUIRED_ERROR } });
    }
    return !!value;
  };

  const onChangePasswordField = (value, validationText, touched) => {
    if (touched) {
      validatePassword(value);
    }
    dispatch({ type: SET_DATA, payload: { password: value } });
  };

  const handleAuthResponse = (response) => {
    if (response.data?.redirect) {
      if (response.data?.redirect === AUTH_LOGIN) {
        setLoading(false);
      } else {
        window.location.href = response.data.redirect;
      }
      return;
    }
    if (response.data?.render) {
      if (response.data?.render === 'password_reset') {
        window.location.href = AUTH_PASSWORD_RESET_CONFIRMATION;
      }
    } else {
      setLoading(false);
      window.toastr.error(
        "We don't recognize your email or password. Please try again or reset password below."
      );
    }
  };

  const executeEmailPasswordLogin = async () => {
    const response = await postData({
      url: AUTH_LOGIN,
      body: {
        user: {
          email,
          password
        }
      }
    });
    if (response.data?.error) {
      window.toastr.error(response.data.error);
    }
    handleAuthResponse(response);
  };

  const submitCredentials = async () => {
    dispatch(validateAction('email'));
    if (!validatePassword(password) || !email || errors.email) {
      return;
    }
    setLoading(true);
    await executeEmailPasswordLogin();
  };

  return (
    <>
      <div id='this-is-the-one' css={loginContainerStyles}>
        <RebrandEmail
          additionalStyle={{
            '.MuiOutlinedInput-notchedOutline': {
              border: '1px solid #CACACA'
            }
          }}
          briteVerify={false}
        />
        <Password
          additionalProp={{ hideRequirements: true }}
          onChange={onChangePasswordField}
          value={password}
          onMount={onChangePasswordField}
          onSubmit={submitCredentials}
          error={passwordError}
        />
        <LinkButton
          lightBackground
          additionalStyle={forgotLinkButtonStyles}
          onClick={() => navigate(AUTH_PASSWORD_NEW)}
        >
          Forgot Password
        </LinkButton>
      </div>

      <div css={buttonContainerStyles}>
        <Button
          css={loginButtonStyles}
          onClick={submitCredentials}
          loading={loading}
        >
          Log In
        </Button>
        <Button
          css={buttonStyles}
          onClick={() => navigate(AUTH_MAGIC_LINK_LOGIN)}
        >
          <ArrowPhone />
          Login with a secure link
        </Button>
      </div>
    </>
  );
}

export default EmailPasswordLoginForm;
